import React from 'react';
import Footer from '@/components/Footer';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

const Terms = () => {
  return (
    <div className="min-h-screen bg-stone-50 flex flex-col font-sans">
      {/* Header */}
      <header className="bg-stone-50/90 backdrop-blur-sm border-b border-stone-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3.5">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2 sm:gap-2.5 hover:opacity-75 transition-opacity duration-150 flex-shrink-0">
              <img 
                src="/icon-192x192.png" 
                alt="PGastos" 
                className="h-7 sm:h-8 w-auto"
              />
              <span className="text-base sm:text-lg font-bold text-stone-900 tracking-tight">PGastos</span>
            </Link>
            <Link to="/">
              <Button variant="outline" size="sm" className="border-stone-300 hover:bg-stone-100 text-stone-700 text-xs sm:text-sm active:scale-95 transition-all duration-150 ease-spring cursor-pointer">
                <ArrowLeft className="w-4 h-4 mr-1.5" />
                Volver
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 w-full">
        <Card className="bg-white rounded-3xl border border-stone-200 shadow-sm p-7 sm:p-12">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-stone-900 text-white flex items-center justify-center">
              <FileText className="w-5 h-5 text-indigo-400" />
            </div>
            <div>
              <h1 className="text-2xl sm:text-3xl font-black text-stone-900 tracking-tight">Términos y Condiciones</h1>
              <p className="text-xs text-stone-400 font-medium">Última actualización: Septiembre 2026</p>
            </div>
          </div>

          <div className="space-y-8 text-stone-600 text-sm sm:text-base leading-relaxed font-medium mt-8 divide-y divide-stone-100">
            <section className="pt-6 first:pt-0">
              <h2 className="text-lg font-bold text-stone-900 mb-3">1. Aceptación de los Términos</h2>
              <p>
                Al acceder y utilizar PGastos ("la aplicación", "el servicio"), operado por VJRDEV Company, 
                aceptas estar sujeto a estos Términos y Condiciones. Si no estás de acuerdo con alguna 
                parte de estos términos, no debes utilizar nuestros servicios.
              </p>
            </section>

            <section className="pt-6">
              <h2 className="text-lg font-bold text-stone-900 mb-3">2. Naturaleza del Servicio</h2>
              <p className="mb-3">
                PGastos es una plataforma digital de asistencia y registro financiero personal. Ofrece:
              </p>
              <ul className="list-disc list-inside space-y-1.5 ml-2 text-stone-600">
                <li>Registro manual y por voz de transacciones personales</li>
                <li>Control de cuentas bancarias, tarjetas de crédito y compras a MSI</li>
                <li>Organización de deudas personales y generación de ligas para pago SPEI</li>
                <li>Asistente inteligente con análisis y proyecciones de gasto</li>
              </ul>
              <div className="mt-4 p-4 bg-stone-50 rounded-2xl border border-stone-200 text-xs sm:text-sm text-stone-700">
                <strong>Importante:</strong> PGastos <strong>no es una entidad financiera ni un procesador de pagos</strong>. No captamos fondos, no gestionamos cuentas de depósito ni realizamos transferencias directamente. Las transferencias entre usuarios se realizan de banco a banco a través del sistema bancario mexicano.
              </div>
            </section>

            <section className="pt-6">
              <h2 className="text-lg font-bold text-stone-900 mb-3">3. Cuenta y Responsabilidad</h2>
              <ul className="list-disc list-inside space-y-1.5 ml-2 text-stone-600">
                <li>Debes ser mayor de 18 años para utilizar el servicio</li>
                <li>Eres responsable de la veracidad de los datos que ingreses</li>
                <li>Debes mantener la confidencialidad de tu contraseña</li>
                <li>Puedes solicitar la cancelación o baja de tu cuenta en cualquier momento</li>
              </ul>
            </section>

            <section className="pt-6">
              <h2 className="text-lg font-bold text-stone-900 mb-3">4. Planes y Suscripciones</h2>
              <ul className="list-disc list-inside space-y-1.5 ml-2 text-stone-600">
                <li><strong>Plan Gratis:</strong> Gratuito para siempre sin requerir tarjeta de crédito</li>
                <li><strong>Planes de Pago (Premium / Pro):</strong> Ofrecen pruebas gratuitas de 14 días. Las suscripciones se cobran a través de la pasarela segura Stripe y se pueden cancelar en cualquier momento sin penalizaciones</li>
              </ul>
            </section>

            <section className="pt-6">
              <h2 className="text-lg font-bold text-stone-900 mb-3">5. Propiedad Intelectual</h2>
              <p>
                Todos los derechos de software, interfaces, marca y contenidos de PGastos son propiedad exclusiva de VJRDEV Company.
              </p>
            </section>

            <section className="pt-6">
              <h2 className="text-lg font-bold text-stone-900 mb-3">6. Contacto y Dudas Legales</h2>
              <div className="p-4 bg-stone-50 rounded-2xl border border-stone-200 text-xs sm:text-sm">
                <p className="font-bold text-stone-900">VJRDEV Company</p>
                <p className="text-stone-500">Email: <a href="mailto:soporte@capacitatu.com" className="text-indigo-600 hover:underline">soporte@capacitatu.com</a></p>
                <p className="text-stone-500">Web: <a href="https://vjrodriguez.dev" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline">vjrodriguez.dev</a></p>
              </div>
            </section>
          </div>
        </Card>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;
